/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// Fix sticky product image on PDP

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.shopify-section--main-product')) {
    document.addEventListener('scroll', (e) => {
      if (window.innerWidth < 1000) return;
      const imageEl = document.querySelector('.cl-po--gallery');
      const imageElInner = document.querySelector('.cl-po--gallery-main .splide__list');
      const imageWrapperEl = document.querySelector('.cl-po--gallery-wrapper');
      const header = document.querySelector('.shopify-section--header');
      const productInfo = document.querySelector('.product__info');
      if (imageEl){
        if (imageWrapperEl && header && document.documentElement.scrollTop > (header.getBoundingClientRect().height + imageWrapperEl.getBoundingClientRect().top)) {
          let offset = document.documentElement.scrollTop + header.getBoundingClientRect().height - (window.scrollY + imageWrapperEl.getBoundingClientRect().top);
          if (imageElInner && productInfo && productInfo.getBoundingClientRect().height <= (offset + imageElInner.getBoundingClientRect().height + 50)) {
          } else {
            imageEl.style.marginTop = `${offset}px`;
          }
        } else {
          imageEl.style.marginTop = '0px';
        }
      }

    });
  }
})

/**
 * Max qty
 */
document.addEventListener('variant:changed', (event) => {
  const { variant } = event.detail;
  event.target.closest('.product-form').querySelector('.quantity-selector').dataset.selectedVariantId = variant.id;

  const qtyEl = document.querySelector(`quantity-selector[data-selected-variant-id="${variant.id}"]`);

  calcMaxData(qtyEl, variant.id, 'variant:changed');
});

document.addEventListener('cart:updated', (event) => {
  const { items } = event.detail.cart;
  const itemsRemoved = event.detail.cart.items_removed;

  if (items) {
    items.forEach(item => {
      let qtyEls = document.querySelectorAll(`.quantity-selector[data-selected-variant-id='${item.id}']`);
      if (qtyEls.length === 0) {
        qtyEls = document.querySelectorAll(`.product-item__quick-form button[data-selected-variant-id='${item.id}']`);
      }
      qtyEls.forEach(qtyEl => {
        calcMaxData(qtyEl, item.id, 'cart:updated');
      })
    })
  }

  if (itemsRemoved) {
    itemsRemoved.forEach(item => {
      let qtyEls = document.querySelectorAll(`.quantity-selector[data-selected-variant-id='${item.variant_id}']`);
      if (!qtyEls) {
        qtyEls = document.querySelectorAll(`.product-item__quick-form[data-selected-variant-id='${item.id}']`);
      }
      qtyEls.forEach(qtyEl => {
        calcMaxData(qtyEl, item.variant_id, 'cart:updated');
      })
    })
  }

});

document.addEventListener('custom:quantity-changed', (data) => {
  const { input } = data.detail;
  const qtyEl = input.closest('.quantity-selector');
  const variantId = qtyEl.dataset.selectedVariantId;

  // const variantsMaxData = JSON.parse(qtyEl.dataset.variantsMaxQty);
  // const variantsAvailableData = JSON.parse(qtyEl.dataset.variantsAvailable);
  // const globalMax = qtyEl.dataset.globalMaxQty;

  calcMaxData(qtyEl, variantId, 'custom:quantity-changed');
});

window.addEventListener('options:rendered', (data) => {
  const qtyEls = document.querySelectorAll('product-rerender .quantity-selector');
  qtyEls.forEach(qtyEl => {
    calcMaxData(qtyEl, qtyEl.dataset.selectedVariantId, 'cloudlift.options.ready');
  })
});


function triggerMaxMessage(variantId, variantMax, messageType) {
  const messageBoxes = document.querySelectorAll(`.quantity-selector[data-selected-variant-id="${variantId}"] + .qty-max-info`);
  messageBoxes.forEach(messageBox => {
    messageBox.querySelectorAll('.qty-max-info__text').forEach(el => {
      el.classList.add('qty-max-info__text--hidden');
    });
    switch (messageType) {
      case 'hide':
        messageBox.classList.add('qty-max-info--hidden');
        break;
      case 'low_stock':
        messageBox.classList.remove('qty-max-info--hidden');
        messageBox.querySelector('.qty-max--low-stock').classList.remove('qty-max-info__text--hidden');
        break;
      case 'sold_out':
        messageBox.classList.remove('qty-max-info--hidden');
        messageBox.querySelector('.qty-max--sold-out').classList.remove('qty-max-info__text--hidden');
        break;
      case 'max_limit':
        messageBox.classList.remove('qty-max-info--hidden');
        messageBox.querySelector('.qty-max--limit').classList.remove('qty-max-info__text--hidden');
        messageBox.querySelector('.qty-max--limit .qty-max-info__qty').innerText = variantMax;
        break;
      default:
        break;
    }
  });
}

function calcMaxData(qtyEl, variantId, action) {
  let inCartQty = 0;

  if (qtyEl.tagName === 'BUTTON') {
    qtyEl.style.display = 'none';
  }

  getCart()
    .then(data => {
      data.items?.forEach(item => {
        if (+item.variant_id === +variantId) {
          inCartQty = +item.quantity;
        }
      });
    })
    .then(data => {
      triggerMaxMessage(variantId, 0, 'hide');

      const variantInventoryPolicy = JSON.parse(qtyEl.dataset.inventoryPolicy)[variantId];
      const variantInventoryTrack = JSON.parse(qtyEl.dataset.inventoryTrack)[variantId];

      if (qtyEl && qtyEl.dataset.variantsMaxQty != 'undefined') {
        const variantsMaxData = +JSON.parse(qtyEl.dataset.variantsMaxQty)[variantId];
        let variantsAvailableData = +JSON.parse(qtyEl.dataset.variantsAvailable)[variantId];
        const globalMax = +qtyEl.dataset.globalMaxQty;

        if (variantInventoryPolicy === 'continue' || variantInventoryTrack === 'none') {
          variantsAvailableData = 999999;
        }


        let messageType = 'max_limit';
        let variantMax;

        if (globalMax > 0) {
          const variantValue = +qtyEl.querySelector('.quantity-selector__input').value;
          const currentMax = variantsMaxData === 0 ? globalMax : variantsMaxData;

          if (currentMax > variantsAvailableData) {
            variantMax = variantsAvailableData;
            messageType = 'sold_out';
          } else if ((inCartQty + variantValue) >= variantsAvailableData) {
            variantMax = variantsAvailableData;
            messageType = 'max_limit';
          }

          if (variantsAvailableData > currentMax) {
            variantMax = currentMax;
            messageType = 'max_limit';
          }

          qtyEl.querySelector('.quantity-selector__input').setAttribute('max', (+variantMax - inCartQty));

          if (variantsAvailableData < 5) {
            messageType = 'low_stock';
            triggerMaxMessage(variantId, variantMax, messageType);
          }

          if ((variantMax - inCartQty) === 0) {
            qtyEl.querySelector('.quantity-selector__input').value = 0;
            qtyEl.querySelector('.quantity-selector__input').setAttribute('min', 0);
            qtyEl.querySelector('.quantity-selector__input').setAttribute('max', 0);
            if (variantsAvailableData > inCartQty) {
              messageType = 'max_limit';
            } else {
              messageType = 'sold_out';
            }
          } else if (variantValue === 0 && (variantMax - inCartQty) > 0) {
            qtyEl.querySelector('.quantity-selector__input').value = 1;
            qtyEl.querySelector('.quantity-selector__input').setAttribute('min', 1);
          }

          if (variantValue >= (variantMax - inCartQty)) {
            qtyEl.querySelector('.quantity-selector__input').value = Math.max((variantMax - inCartQty), 0);
            if ((variantMax - inCartQty) > 0) {
              qtyEl.querySelector('.quantity-selector__input').setAttribute('min', 1);
            }
            if (action !== 'cart:updated' || (variantMax - inCartQty) < 5) {
              triggerMaxMessage(variantId, variantMax, messageType);
            }
          }
        }
      }
    })
}


async function getCart() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


document.addEventListener('DOMContentLoaded', () => {
  window.LACROSSE_APP.utils.initTeamsDataFromAdmin();
});

/**
 * General LACROSSE_APP  config
 */
window.LACROSSE_APP = {
  constants: {
    API_ENDPOINTS: {
      MENU: 'getMenuGames',
      GAME: 'getMatch',
      SCORES: 'getScores',
      TEAM: 'getTeamFull',
      TEAMS: 'getTeams',
      TOP_TEAMS: 'getTopTeams',
      STATS: 'getStats',
      PLAYER: 'getPlayer',
      PLAYERS: 'getRoster',
      SCHEDULE: 'getSchedule',
      CALENDAR: 'getCalendar',
      CONFERENCES_TEAMS: 'getConferencesTeams',
      CONFERENCES: 'getConferences',
      SEARCH: 'search',
      GAMES: 'getDivisionGames',
      GAMES_DATES: 'getDivisionGamesDates',
      CONFERENCES_YEARS: 'getDivisionsYears',
      HOMEPAGE_SCORES_STATS_GAMES: 'getLastGames',
      TEAM_YEARS: 'getTeamYears',
    },
    DIVISIONS: [
      { label: "Men's Division 1", label_short: 'mens', value: 1 },
      { label: "Men's Division 2", label_short: 'mens', value: 2 },
      { label: "Men's Division 3", label_short: 'mens', value: 3 },
      { label: "Women's Division 1", label_short: 'womens', value: 4 },
      { label: "Women's Division 2", label_short: 'womens', value: 5 },
      { label: "Women's Division 3", label_short: 'womens', value: 6 },
    ],
    PLAYER_POSITIONS: {
      a: "Attack",
      m: "Midfield",
      d: "Defense",
      g: "Goalie",
      fo: "Faceoff Specialist",
      lsm: "Long Stick Midfielder",
      ssdm: "Short Stick Defensive Midfielder",
      om: "Offensive Midfielder",
      dm: "Defensive Midfielder",
    },
    PLAYER_CLASS: {
      gr: "Graduate",
      sr: "Senior",
      jr: "Junior",
      so: "Sophomore",
      fr: "Freshman",
      g: "Goalie"
    },
    CONFERENCES_TH_TITLES: ["RANK", "RECORD", "CONFERENCE RECORD", "GOALS FOR", "GOALS AGAINST"],
    PLAYER_TH_TITLES: ["Date", "Game", "G", "A", "S", "GA", "SH", "GB", "TO", "CT", "F/O", "FOT"],
    PLAYER_INFO: {
      position: "Position",
      city: "City",
      class: "Class",
      state: "State",
    },
    CURRENT_YEAR: new Date().getFullYear(),
    DEFAULT_PLAYER_ID: "26072", //TODO: Default player id - HEATHER HANSON ?
    DEFAULT_GAME_ID: "7235", //TODO: Default game id - Colby-Sawyer VS Lasell ?
    MATCH_STATUS: {
      live: "LIVE",
      preMatch: "PREMATCH",
      final: "FINAL"
    },
    STATS: {
      player: [
        { label: "All Stats", value: "all" },
        { label: "Points", value: "points" },
        { label: "Goals", value: "goals" },
        { label: "Assists", value: "assists" },
        { label: "Saves", value: "saves" },
        { label: "Faceoffs", value: "faceoffs" },
        { label: "Ground balls", value: "ground_balls" },
        { label: "Turnovers", value: "turnovers" },
        { label: "Caused Turnovers", value: "caused_turnovers" },
        { label: "Shots", value: "shots" },
      ],
      team: [
        { label: "All Stats", value: "all" },
        { label: "Offense", value: "offense" },
        { label: "Defense", value: "defense" },
        { label: "Goal differential", value: "goaldiff" },
      ]
    },
    STATS_TABLE: [
      {
        key: "points",
        titles: ["#", "Name", "Team", "Pts", "Goals", "Asts", "Avg"],
        property: ["index", "name", "team_name", "points", "goals", "assists", "avg"],
      },
      {
        key: "goals",
        titles: ["#", "Name", "Team", "Goals", "Avg"],
        property: ["index", "name", "team_name", "goals", "avg"]
      },
      {
        key: "assists",
        titles: ["#", "Name", "Team", "A", "Avg"],
        property: ["index", "name", "team_name", "assists", "avg"]
      },
      {
        key: "saves",
        titles: ["#", "Name", "Team", "Saved", "Faced", "Avg"],
        property: ["index", "name", "team_name", "shots_saved", "shots_faced", "avg"]
      },
      {
        key: "faceoffs",
        titles: ["#", "Name", "Team", "Won", "Taken", "Avg"],
        property: ["index", "name", "team_name", "faceoffs_won", "faceoffs_taken", "avg"]
      },
      {
        key: "ground_balls",
        titles: ["#", "Name", "Team", "GB", "Avg"],
        property: ["index", "name", "team_name", "ground_balls", "avg"]
      },
      {
        key: "turnovers",
        titles: ["#", "Name", "Team", "TO", "Avg"],
        property: ["index", "name", "team_name", "turnovers", "avg"]
      },
      {
        key: "caused_turnovers",
        titles: ["#", "Name", "Team", "CT", "Avg"],
        property: ["index", "name", "team_name", "caused_turnovers", "avg"]
      },
      {
        key: "shots",
        titles: ["#", "Name", "Team", "Shots", "Avg"],
        property: ["index", "name", "team_name", "shots", "avg"]
      },
      {
        key: "offense",
        titles: ["#", "Team", "GF", "Avg"],
        property: ["index", "team_name", "goals_for", "avg"]
      },
      {
        key: "defense",
        titles: ["#", "Team", "GA", "Avg"],
        property: ["index", "team_name", "goals_against", "avg"]
      },
      {
        key: "goaldiff",
        titles: ["#", "Team", "For", "Against", "Diff"],
        property: ["index", "team_name", "for", "against", "diff"]
      }
    ],
    PAGES_META_DATA: {
      scores: {
        title: 'Live Lacrosse Scores | ${x}',
        description: 'Live College Lacrosse Scores from ${x} NCAA.  See all the latest lacrosse scores, stats, and highlights at Lax.com'
      },
      stats: {
        title: 'Live Lacrosse Stats | ${x}',
        description: 'Live College Lacrosse Stats from ${x} NCAA.  See all the latest lacrosse scores, stats, and highlights at Lax.com'
      },
      match: {
        title: '${x} Lacrosse Scores & Stats ${y}',
        description: '${x} Lacrosse Scores & Stats ${y}. See all the latest lacrosse scores, stats, and highlights at Lax.com'
      },
      teams: {
        title: 'College Lacrosse Teams | ${x}',
        description: '${x} College Lacrosse Teams. Top 20 Team Rankings. See all the latest lacrosse scores, stats, and highlights at Lax.com'
      },
      team: {
        title: '${x} Lacrosse Stats ${y}',
        description: '${x} Lacrosse Stats ${y}. See all the latest lacrosse scores, stats, and highlights at Lax.com'
      },
      player: {
        title: '${x} Lacrosse Stats ${z} ${y}',
        description: '${x} Lacrosse Stats - ${z}, ${y}. See all the latest lacrosse scores, stats, and highlights at Lax.com'
      },
      calendar: {
        title: 'College Lacrosse Game Calendar | ${x}',
        description: 'Live College Lacrosse Stats from ${x} NCAA.  See all the latest lacrosse scores, stats, and highlights at Lax.com'
      },
      conferences: {
        title: 'College Lacrosse Conferences | ${x}',
        description: '${x} College Lacrosse Conference Standings. See all the latest lacrosse scores, stats, and highlights at Lax.com'
      }
    }
  },
  dynamicData: {
    TEAMS: [],
    LACROSSE_YEAR_SWIPER: null,
    LACROSSE_STATS_ADS: null
  },
  api: {
    BASE_URL: "https://www.laxshop.com/shopify_stats.php",
  },
  fetchFunctions: {
    fetchData: async function(endpoint, params = {}, showError = false) {
      const url = window.LACROSSE_APP.api.BASE_URL;
      try {
        const fullParams = { ...params, action: endpoint };
        const queryString = new URLSearchParams(fullParams).toString();
        const fullUrl = `${url}?${queryString}`;
        const response = await fetch(fullUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.clone().text().then(text => {
          if (!text) {
            return {};
          }
          return response.json();
        });
      } catch (error) {
        if(!showError) {
          window.LACROSSE_APP.utils.removeLoadingBox();
          window.location.replace("/pages/404-scores-stats");
          console.error('Error during fetch request:', error);
        }
        throw error;
      }
    },
    fetchConferences: async function(division, year) {
      const params = {division};
      if(year) params.year = year;
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.CONFERENCES, params);
    },
    fetchConferencesTeam: async function({division, conference, year}) {
      const params = {division};
      if(year) params.year = year;
      if(conference !== 'all') params.conference = conference;
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.CONFERENCES_TEAMS, params);
    },
    fetchTeam: async function({url_name,year}) {
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.TEAM, { url_name, year });
    },
    fetchTeamYears: async function({url_name}) {
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.TEAM_YEARS, { url_name });
    },
    fetchTeams: async function(division) {
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.TEAMS, { division });
    },
    fetchTopTeams: async function({division, year = LACROSSE_APP.constants.CURRENT_YEAR, limit = 20}) {
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.TOP_TEAMS, { division, year, limit }, true);
    },
    fetchLastGames: async function({division, year = LACROSSE_APP.constants.CURRENT_YEAR}) {
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.HOMEPAGE_SCORES_STATS_GAMES, { division, year }, true);
    },
    fetchScores: async function({ division, dateBegin, conference }) {
      const params = {dateBegin, division};
      if(conference !== 'all') params.conference = conference;
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.SCORES, params);
    },
    fetchGame: async function(game_id, year = LACROSSE_APP.constants.CURRENT_YEAR) {
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.GAME, {game_id, year});
    },
    fetchPlayer: async function(player_id, year) {
      const params = {player_id};
      if(year) params.year = year;
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.PLAYER, params);
    },
    fetchStats: async function({year, division, grade, conference, showError = false}) {
      const params = {year, division};
      if(grade !== 'all') params.grade = grade;
      if(conference !== 'all') params.conference = conference;

      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.STATS, params, showError);
    },
    fetchMenu: async function(dateBegin, final) {
      const params = {};
      if(dateBegin) {
        params.dateBegin = dateBegin;
        params.final = final;
      }
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.MENU, params, true);
    },
    fetchDivisionGames: async function({division, dateBegin}) {
      const params = {division};
      if(dateBegin) params.dateBegin = dateBegin;
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.GAMES, params);
    },
    fetchDivisionGamesDates: async function({division}) {
      const params = {division};
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.GAMES_DATES, params, true);
    },
    fetchAllDivisionsConferencesYears: async function() {
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.CONFERENCES_YEARS, {});
    },
    fetchAllTeamsFromAdmin: async function (hasNextPage = true, next_url = '') {
      if (!hasNextPage) {
        sessionStorage.setItem('LACROSSE_APP_TEAM', JSON.stringify(window.LACROSSE_APP.dynamicData.TEAMS));
        return;
      }
      try {
        const url = next_url || `/pages/scores?view=json-export&limit=1000`;
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        if (data.lacrosse_teams && data.page_index) {
          const { page_index, lacrosse_teams } = data;
          const hasNextPage = data.pagination_next !== null;
          if (lacrosse_teams?.length) {
            window.LACROSSE_APP.dynamicData.TEAMS.push(...lacrosse_teams);
          }
          await window.LACROSSE_APP.fetchFunctions.fetchAllTeamsFromAdmin(hasNextPage, data.pagination_next?.url);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    },
    fetchYouMayLikeSection: async function (sectionID, collection, title) {
      const youMayLikeSection = document.querySelector(('.you-may-like-section .container.container--custom'));
      if (!youMayLikeSection) return;

      let url = `${window.location.href}?sections=${sectionID}`;
      if (collection) {
        url += `&collection=${encodeURIComponent(collection)}`;
      }
      if (title) {
        url += `&title=${encodeURIComponent(title)}`;
      }
      fetch(url)
          .then(response => response.text())
          .then(html => {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const fetchedSection = tempDiv.querySelector('.you-may-like-section');
            if (fetchedSection) {
              const currentPageSection = document.querySelector('.you-may-like-section');
              if (currentPageSection) {
                currentPageSection.innerHTML = fetchedSection.innerHTML;
                const swiper = new Swiper("#you-may-like__swiper", {
                  slidesPerView: 1,
                  spaceBetween: 10,
                  breakpoints: {
                    450: {
                      slidesPerView: 1.5,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: 2.8,
                      spaceBetween: 35,
                    },
                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 35,
                    }
                  },
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                });
                LACROSSE_APP.utils.moveQuickViewBoxes('.you-may-like-section');
              }
            }
          })
          .catch(error => {
            console.error('Error fetching the content:', error);
          });
    },
    fetchSearchResults: async function(s) {
      return await window.LACROSSE_APP.fetchFunctions.fetchData(window.LACROSSE_APP.constants.API_ENDPOINTS.SEARCH, {s: s}, true);
    }
  },
  utils: {
    initTeamsDataFromAdmin: async function () {
      const getTeams = sessionStorage.getItem('LACROSSE_APP_TEAM');
      if(getTeams) {
        window.LACROSSE_APP.dynamicData.TEAMS = JSON.parse(getTeams);
        return;
      }
      window.LACROSSE_APP.dynamicData.TEAMS = [];
      await window.LACROSSE_APP.fetchFunctions.fetchAllTeamsFromAdmin();
    },
    getTeamsDataFromAdmin: function (url_name) {
      let bio = "";
      let team_logo = "";
      let brand_color = "";
      let you_may_like_collection = "";
      let collection_section_title = "";

      const dataFromAdmin = window.LACROSSE_APP.dynamicData.TEAMS?.find(team => team.url_name === url_name);
      if(dataFromAdmin){
        bio = dataFromAdmin.bio;
        brand_color = dataFromAdmin.brand_color;
        you_may_like_collection = dataFromAdmin.you_may_like_collection;
        collection_section_title = dataFromAdmin.collection_section_title;
        if(dataFromAdmin.team_logo && !dataFromAdmin.team_logo.includes('no-image-')) {
          team_logo = dataFromAdmin.team_logo ;
        }
      }

      return {
        brand_color,
        team_logo,
        bio,
        you_may_like_collection,
        collection_section_title
      }
    },
    getURLParameter: function(paramName) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(paramName);
    },
    updateHistoryState: function (data, title, url, replace = false) {
      if (replace) {
        history.replaceState(data, title, url);
      } else {
        history.pushState(data, title, url);
      }
    },
    updateURLParameter: function (paramName, paramValue) {
      const baseUrl = window.location.origin + window.location.pathname;
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has(paramName)) {
        urlParams.set(paramName, paramValue);
      } else {
        urlParams.append(paramName, paramValue);
      }

      const newUrl = baseUrl + '?' + urlParams.toString();

      window.LACROSSE_APP.utils.updateHistoryState({}, document.title, newUrl, true);
    },
    debounce: function(func, wait) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    },
    UseShadowScroll: class UseShadowScroll {
      constructor(selector) {
        this.wrapper = typeof selector === "string" ? document.querySelector(selector) : selector;
        this.content = this.wrapper.querySelector('.scroll-shadowed__scroll');
        this.shadowLeft = this.wrapper.querySelector('.scroll-shadowed__shadow--left');
        this.shadowRight = this.wrapper.querySelector('.scroll-shadowed__shadow--right');

        window.addEventListener('resize', this.changeShadow.bind(this));
        this.content.addEventListener('scroll', this.changeShadow.bind(this));
      }

      changeShadow() {
        if (this.content.scrollWidth === this.content.getBoundingClientRect().width) {
          this.shadowLeft.classList.add('_hidden');
          this.shadowRight.classList.add('_hidden');
        } else {
          this.shadowLeft.classList.remove('_hidden');
          this.shadowRight.classList.remove('_hidden');
        }

        if (this.content.scrollLeft > 50) {
          this.shadowLeft.style.opacity = "1";
        } else {
          this.shadowLeft.style.opacity = "0";
        }

        if (this.content.scrollWidth < this.content.scrollLeft + this.content.getBoundingClientRect().width + 50) {
          this.shadowRight.style.opacity = "0";
        } else {
          this.shadowRight.style.opacity = "1";
        }
      }
    },
    createElementFromHTMLString: (htmlString) => {
      const div = document.createElement('div');
      div.innerHTML = htmlString.trim();
      return div.firstChild;
    },
    createCustomSelect: function(containerId, options, activeElement, disableElement = ['']) {
      if(options?.length === 0) return;
      const customSelectContainer = document.getElementById(containerId);
      const icon = customSelectContainer.dataset.icon || null;

      const generateOptionList = (options, selectedElement, itemsDiv, selectedDiv, customSelectInput, disableElement) => {
        //clean up
        itemsDiv.innerHTML = '';
        const changeEvent = new Event('change');
        let hasSelectedOption = false;
        for (const option of options) {
          const itemDiv = document.createElement('div');
          itemDiv.classList.add('custom-select_item');
          const disabled = Boolean(disableElement.find(element => element === option.value));
          itemDiv.classList.toggle('disable', disabled);
          itemDiv.innerText = option.label;
          itemDiv.dataset.option = option.value;
          itemDiv.addEventListener('click', (e) => {
            if (disabled) {
              e.preventDefault();
              return;
            }
            selectedDiv.innerHTML = `<div class="select-selected__text">${e.target.innerText}</div>`;
            selectedDiv.appendChild(arrowDiv);
            selectedDiv.setAttribute('title', e.target.innerText);
            selectedDiv.dataset.option = e.target.dataset.option;
            customSelectInput.value = e.target.dataset.option;
            customSelectInput.dispatchEvent(changeEvent)
            itemsDiv.classList.remove('select-open');
            selectedDiv.classList.remove('open');
            if(option.direction) {
              selectedDiv.appendChild(this.createElementFromHTMLString(sortIcons[option.direction]));
            }
          });
          if (selectedElement.toString() === option?.value?.toString()) {
            hasSelectedOption = true;
            selectedDiv.innerHTML = `<div class="select-selected__text">${option.label}</div>`;
            selectedDiv.setAttribute('title', option.label);
            selectedDiv.appendChild(arrowDiv);
            selectedDiv.dataset.option = option.value;
            customSelectInput.value = option.value;
            firstElementSelected = true;
            if(option.direction) {
              selectedDiv.appendChild(this.createElementFromHTMLString(sortIcons[option.direction]));
            }
          }
          itemsDiv.appendChild(itemDiv);
        }

        if(!hasSelectedOption) {
          selectedDiv.innerHTML = `<div class="select-selected__text">${options[0].label}</div>`;
          selectedDiv.setAttribute('title', options[0].label);
          selectedDiv.appendChild(arrowDiv);
          selectedDiv.dataset.option = options[0].value;
          customSelectInput.value = options[0].value;
          if(options[0].direction) {
            selectedDiv.appendChild(this.createElementFromHTMLString(sortIcons[options[0].direction]));
          }
        }
      }

      const arrowSvg = `
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M5.83337 9.16683L12.5 15.8335L19.1667 9.16683" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;

      const sortDescSvg = `
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="select-selected__sort-direction">
          <g clip-path="url(#clip0_104_10)">
            <path d="M13.045 3.94439V3.27005C13.045 2.89761 12.7663 2.5957 12.4225 2.5957H3.74747C3.40368 2.5957 3.125 2.89761 3.125 3.27005V3.94439C3.125 4.31683 3.40368 4.61873 3.74747 4.61873H12.4225C12.7663 4.61873 13.045 4.31683 13.045 3.94439Z" fill="black"/>
            <path d="M11.2536 6.84375H3.74747C3.40368 6.84375 3.125 7.14565 3.125 7.51809V8.19244C3.125 8.56488 3.40368 8.86678 3.74747 8.86678H11.2536C11.5974 8.86678 11.8761 8.56488 11.8761 8.19244V7.51809C11.8761 7.14565 11.5974 6.84375 11.2536 6.84375Z" fill="black"/>
            <path d="M10.0845 11.0923H3.74747C3.40368 11.0923 3.125 11.3942 3.125 11.7666V12.441C3.125 12.8134 3.40368 13.1153 3.74747 13.1153H10.0845C10.4283 13.1153 10.707 12.8134 10.707 12.441V11.7666C10.707 11.3942 10.4283 11.0923 10.0845 11.0923Z" fill="black"/>
            <path d="M8.91553 15.8125H3.74747C3.40368 15.8125 3.125 16.1144 3.125 16.4868V17.1612C3.125 17.5336 3.40368 17.8355 3.74747 17.8355H8.91553C9.25926 17.8355 9.538 17.5336 9.538 17.1612V16.4868C9.538 16.1144 9.25932 15.8125 8.91553 15.8125Z" fill="black"/>
            <path d="M7.74647 20.0605H3.74747C3.40368 20.0605 3.125 20.3625 3.125 20.7349V21.4092C3.125 21.7817 3.40368 22.0836 3.74747 22.0836H7.74647C8.0902 22.0836 8.36894 21.7817 8.36894 21.4092V20.7349C8.36894 20.3625 8.09026 20.0605 7.74647 20.0605Z" fill="black"/>
            <path d="M21.6912 16.9685L21.251 16.4916C21.1343 16.3652 20.9759 16.2941 20.8109 16.2941C20.6458 16.2941 20.4874 16.3652 20.3707 16.4916L18.2298 18.8109V3.60696C18.2298 3.23452 17.9511 2.93262 17.6073 2.93262H16.9849C16.6411 2.93262 16.3624 3.23452 16.3624 3.60696V18.8108L14.2215 16.4916C14.1047 16.3651 13.9464 16.2941 13.7814 16.2941C13.6163 16.2941 13.4579 16.3651 13.3412 16.4916L12.901 16.9684C12.658 17.2317 12.658 17.6587 12.901 17.9221L16.8559 22.2066C16.9775 22.3383 17.1368 22.4041 17.2961 22.4041C17.4554 22.4041 17.6147 22.3383 17.7362 22.2066L21.6912 17.9221C21.9342 17.6587 21.9342 17.2317 21.6912 16.9685Z" fill="black"/>
          </g>
          <defs>
            <clipPath id="clip0_104_10">
              <rect width="18.75" height="20.3125" fill="white" transform="translate(3.125 2.34375)"/>
            </clipPath>
          </defs>
        </svg>
      `;

      const sortAscSvg = `
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="select-selected__sort-direction">
        <g clip-path="url(#clip0_104_10)">
          <path d="M11.955 21.0556L11.955 21.73C11.955 22.1024 12.2337 22.4043 12.5775 22.4043L21.2525 22.4043C21.5963 22.4043 21.875 22.1024 21.875 21.73L21.875 21.0556C21.875 20.6832 21.5963 20.3813 21.2525 20.3813L12.5775 20.3813C12.2337 20.3813 11.955 20.6832 11.955 21.0556Z" fill="black"/>
          <path d="M13.7464 18.1563L21.2525 18.1563C21.5963 18.1563 21.875 17.8543 21.875 17.4819L21.875 16.8076C21.875 16.4351 21.5963 16.1332 21.2525 16.1332L13.7464 16.1332C13.4026 16.1332 13.1239 16.4351 13.1239 16.8076L13.1239 17.4819C13.1239 17.8543 13.4026 18.1563 13.7464 18.1563Z" fill="black"/>
          <path d="M14.9155 13.9077L21.2525 13.9077C21.5963 13.9077 21.875 13.6058 21.875 13.2334L21.875 12.559C21.875 12.1866 21.5963 11.8847 21.2525 11.8847L14.9155 11.8847C14.5717 11.8847 14.293 12.1866 14.293 12.559L14.293 13.2334C14.293 13.6058 14.5717 13.9077 14.9155 13.9077Z" fill="black"/>
          <path d="M16.0845 9.1875L21.2525 9.1875C21.5963 9.1875 21.875 8.8856 21.875 8.51316L21.875 7.83881C21.875 7.46637 21.5963 7.16447 21.2525 7.16447L16.0845 7.16447C15.7407 7.16447 15.462 7.46637 15.462 7.83881L15.462 8.51316C15.462 8.8856 15.7407 9.1875 16.0845 9.1875Z" fill="black"/>
          <path d="M17.2535 4.93945L21.2525 4.93945C21.5963 4.93945 21.875 4.63755 21.875 4.26511L21.875 3.59077C21.875 3.21833 21.5963 2.91642 21.2525 2.91642L17.2535 2.91642C16.9098 2.91642 16.6311 3.21833 16.6311 3.59077L16.6311 4.26511C16.6311 4.63755 16.9097 4.93945 17.2535 4.93945Z" fill="black"/>
          <path d="M12.0974 16.6316L11.6573 16.1547C11.5406 16.0283 11.3822 15.9572 11.2171 15.9572C11.052 15.9572 10.8937 16.0283 10.7769 16.1547L8.63604 18.474L8.63604 3.27005C8.63604 2.89761 8.35736 2.5957 8.01357 2.5957L7.3911 2.5957C7.04731 2.5957 6.76863 2.89761 6.76863 3.27005L6.76863 18.4739L4.62777 16.1547C4.51099 16.0282 4.3527 15.9571 4.18762 15.9571C4.02254 15.9571 3.86418 16.0282 3.74747 16.1547L3.30726 16.6315C3.06424 16.8948 3.06424 17.3218 3.30726 17.5851L7.26219 21.8696C7.38375 22.0013 7.54304 22.0672 7.70233 22.0672C7.86162 22.0672 8.02098 22.0013 8.14248 21.8696L12.0974 17.5851C12.3405 17.3218 12.3405 16.8948 12.0974 16.6316Z" fill="black"/>
        </g>
        <defs>
          <clipPath id="clip0_104_10">
            <rect width="18.75" height="20.3125" fill="white" transform="translate(21.875 22.6562) rotate(180)"/>
          </clipPath>
        </defs>
        </svg>
      `;

      const sortIcons = {
        'desc': sortDescSvg,
        'asc': sortAscSvg
      };

      const arrowDiv = this.createElementFromHTMLString(arrowSvg);
      arrowDiv.classList.add('select-selected__icon')

      const selectedElement = activeElement ? activeElement : options[0].value.toString();

      if(customSelectContainer.customSelectCreated === true) {
        const itemsDiv = customSelectContainer.querySelector('.select-items')
        const selectedDiv = customSelectContainer.querySelector('.select-selected');

        const customSelectInput = customSelectContainer.querySelector('input');

        generateOptionList(options, selectedElement, itemsDiv, selectedDiv, customSelectInput, disableElement);
      } else {
        const customSelectInput = customSelectContainer.querySelector('input')
        const selectedDiv = document.createElement('div');
        selectedDiv.classList.add('select-selected');

        const itemsDiv = document.createElement('div');
        itemsDiv.classList.add('select-items');

        generateOptionList(options, selectedElement, itemsDiv, selectedDiv, customSelectInput, disableElement);

        selectedDiv.addEventListener('click', () => {
          itemsDiv.classList.toggle('select-open');
          selectedDiv.classList.toggle('open');
        });
        customSelectContainer.appendChild(selectedDiv);
        customSelectContainer.appendChild(itemsDiv);
        document.addEventListener('click', (e) => {
          if (!customSelectContainer.contains(e.target)) {
            itemsDiv.classList.remove('select-open');
            selectedDiv.classList.remove('open');
          }
        });
        customSelectContainer.customSelectCreated = true;
      }
    },
    setObserverForConferences: function (callback) {
      const conferencesHiddenInput = document.querySelector('#conferences-select input');
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const newConference = conferencesHiddenInput.value;
            const showAll = newConference === 'all';
            callback(newConference, showAll);
          }
        }
      });
      observer.observe(conferencesHiddenInput, { attributes: true });
      conferencesHiddenInput.observer = observer;
    },
    setObserverForDivision: function (division, callback) {
      const divisionHiddenInput = document.querySelector('#division-select input');
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            const divisionValue = divisionHiddenInput.value;
            callback(divisionValue, 'all');
          }
        }
      });
      observer.observe(divisionHiddenInput, { attributes: true });
      divisionHiddenInput.observer = observer;
    },
    initializeConferencesSelect: async function (division, conference = "all", year = null) {
      const allConferences = await window.LACROSSE_APP.fetchFunctions.fetchConferences(division, year);
      const selectedConferences = allConferences?.conferences?.length ? [...allConferences.conferences] : [];
      selectedConferences.unshift({ label: "All Conferences", value: "all" });
      window.LACROSSE_APP.utils.createCustomSelect('conferences-select', selectedConferences, conference);
    },
    setObserverForSelect: function (selectInput,callback) {
      const divisionHiddenInput = document.querySelector(selectInput);
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            if(callback) {
              const divisionValue = divisionHiddenInput.value;
              callback(divisionValue);
            }
          }
        }
      });
      observer.observe(divisionHiddenInput, { attributes: true });
      divisionHiddenInput.observer = observer;
    },
    createYearSlider: function (containerId, years, activeYear, handleCallback) {
      function initializeSlider(containerId) {
        const yearContainer = document.querySelector(`#${containerId} .swiper-wrapper`);
        yearContainer.innerHTML = '';
        if (LACROSSE_APP.dynamicData.LACROSSE_YEAR_SWIPER) {
          LACROSSE_APP.dynamicData.LACROSSE_YEAR_SWIPER.destroy(false, true);
          window.removeEventListener('resize', swiperHandleResize);
        }
        const getDisableNextYear = sessionStorage.getItem('LACROSSE_STATE_DISABLE_NEXT_YEAR');
        const disableNextYear = getDisableNextYear ? JSON.parse(getDisableNextYear) : [''];

        const fragment = document.createDocumentFragment();
        let activeIndex = 0;
        years.forEach((year, index) => {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          slide.setAttribute('data-year', year);
          const disabled = Boolean(disableNextYear.find(element => String(element) === year));
          slide.classList.toggle('disabled', disabled);
          const yearDiv = document.createElement('span');
          yearDiv.className = 'mobile-swiper__year';
          yearDiv.innerHTML = year;
          slide.append(yearDiv);
          if (year === activeYear) {
            activeIndex = index;
            slide.classList.add('active');
          }
          slide.addEventListener('click', (e) => {
            const disabledSlide = Boolean(disableNextYear.find(element => String(element) === slide.querySelector('.mobile-swiper__year').textContent));
            if (disabledSlide) {
              return;
            }
            handleYearClick(slide, yearContainer, handleCallback);
          });
          fragment.appendChild(slide);
        });

        yearContainer.appendChild(fragment);
        initializeSwiper(containerId, activeIndex);
      }

      function initializeSwiper(containerId, activeIndex) {
        LACROSSE_APP.dynamicData.LACROSSE_YEAR_SWIPER = new Swiper(`#${containerId}`, {
          slidesPerView: years.length > 3 ? 3 : years.length,
          slidesPerGroup: 1,
          breakpoints: {
            360: {
              slidesPerView: years.length > 5 ? 5 : years.length,
            },
          },
          navigation: {
            nextEl: '#year-swiper__next.swiper-button-next',
            prevEl: '#year-swiper__prev.swiper-button-prev',
          },
          on: {
            init() {
              this.slideTo(activeIndex);
            }
          }
        });
      }

      function handleYearClick(yearDiv, yearContainer, callback) {
        const pastYear = yearContainer.querySelector('.swiper-slide.active');
        if (pastYear) pastYear.classList.remove('active');
        const newActiveIndex = Array.from(yearContainer.children).indexOf(yearDiv);
        yearDiv.classList.add('active');
        LACROSSE_APP.dynamicData.LACROSSE_YEAR_SWIPER.slideTo(newActiveIndex);
        const selectedYear = yearDiv.textContent;
        LACROSSE_APP.utils.updateURLParameter('year', selectedYear);
        callback(selectedYear);
      }

      function swiperHandleResize() {
        if (window.innerWidth < 768) {
          const yearContainer = document.querySelector(`#${containerId}`);
          const pastYear = yearContainer.querySelector('.swiper-slide.active');
          if (pastYear) pastYear.classList.remove('active');
          const activeYear = LACROSSE_APP.utils.getURLParameter('year');
          const currentSlide = yearContainer.querySelector(`.swiper-slide[data-year="${activeYear}"]`);
          if (currentSlide) currentSlide.classList.add('active');
          const activeIndex = Array.from(document.querySelector(`#${containerId} .swiper-wrapper`).children).indexOf(currentSlide);
          LACROSSE_APP.dynamicData.LACROSSE_YEAR_SWIPER.slideTo(activeIndex);
        }
      }
      initializeSlider(containerId);
      window.addEventListener('resize', swiperHandleResize);
    },
    createLoadingBox: function () {
        const container = document.querySelector('#main[role="main"]');
        if(container) {
          const loadingDiv = document.createElement('div');
          loadingDiv.id = 'loading-data';
          loadingDiv.className = "lacrosse-loading-data";
          const loader  = document.createElement('div');
          loader.className = "game_loader";
          loadingDiv.appendChild(loader);
          container.appendChild(loadingDiv);
        }
    },
    removeLoadingBox: function () {
      const container = document.querySelector('#main[role="main"]');
      if(container) {
        const loadingDiv = container.querySelector('#loading-data');
        if(loadingDiv) {
          loadingDiv.remove();
        }
      }
    },
    getYearOptions: function (generatorNextYear = true) {
      const currentYear = generatorNextYear ? new Date().getFullYear() + 1 : new Date().getFullYear();
      return Array.from({ length: currentYear - 1999 }, (_, i) => ({
        label: (currentYear - i).toString(),
        value: currentYear - i
      }));
    },
    getYearsForSlider: function (generatorNextYear = true) {
      const startYear = 2000;
      const endYear = generatorNextYear ? new Date().getFullYear() + 1 : new Date().getFullYear();
      return Array.from({ length: endYear - startYear + 1 }, (_, i) => `${startYear + i}`);
    },
    getClassesOptions: function () {
      const result = [{ label: "Class of All", value: "all" }];
      result.push(
          ...Object.entries(window.LACROSSE_APP.constants.PLAYER_CLASS)
              .filter(([key]) => key !== 'g')
              .map(([key, value]) => ({ label: value, value: key }))
      );
      return result;
    },
    setSpaceForBottom: function (container) {
      const youMayLikeSection = document.querySelector(('.you-may-like-section'));
      if(!youMayLikeSection) {
        const mainContainer = document.querySelector(container);
        if(mainContainer) {
          if (window.innerWidth > 1200) {
              mainContainer.style.paddingBottom = '100px';
          } else if (window.innerWidth > 767) {
            mainContainer.style.paddingBottom = '80px';
          } else {
            mainContainer.style.paddingBottom = '50px';
          }
        }
      }
    },
    formatDateYMD: function (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    convertToISO8601: function (dateString) {
      const [datePart, timePart] = dateString.split(' ');
      const [time, period] = timePart.split(' ');
      let [hours, minutes] = time.split(':');
      hours = parseInt(hours) + (period === 'PM' && hours < 12 ? 12 : (period === 'AM' && hours === 12 ? -12 : 0));
      return `${datePart}T${hours.toString().padStart(2, '0')}:${minutes}:00`;
    },
    convertDateTimeZone: function (date) {
      const formattedDate = LACROSSE_APP.utils.convertToISO8601(`${date} 12:00 PM`);
      const enDate = new Date(formattedDate);
      return enDate.toLocaleString('en-US', { timeZone: 'America/New_York' })
    },
    getMatchStatus: function ({status, match}) {
      let statusText;
      switch (status) {
        case LACROSSE_APP.constants.MATCH_STATUS.final:
          statusText = status;
          break;
        case LACROSSE_APP.constants.MATCH_STATUS.live:
          let liveDate = "";
          if(match.date) {
            if(match.format === 'text') {
              const liveMatchDay = new Date(match.date + 'T00:00:00');
              liveDate = `${liveMatchDay.getDate()} ${liveMatchDay.toLocaleDateString('en-US', { month: 'short'})}, `;
            } else {
              const [liveYear, liveMonth, liveDay] = match.date.split('-');
              liveDate = `${liveMonth}/${liveDay}/${liveYear.slice(-2)}`;
            }
          }
          statusText = match.clock_status && !match.clock_status.includes('%') ?
              match.clock_status  : `${liveDate ? `${liveDate} `: '' }${match.time}` || 'TBD';
          break;
        case LACROSSE_APP.constants.MATCH_STATUS.preMatch:
        default:
          let date = "";
          if(match.date) {
            if(match.format === 'text') {
              const matchDay = new Date(match.date + 'T00:00:00');
              date = `${matchDay.getDate()} ${matchDay.toLocaleDateString('en-US', { month: 'short'})}, `;
            } else {
              const [year, month, day] = match.date.split('-');
              date = `${month}/${day}/${year.slice(-2)}`;
            }
          }
          statusText = `${date ? `${date} `: ''}${match.time}`;
          break;
      }

      return statusText;
    },
    getNewCanonical: function(url) {
      const urlObj = new URL(url);
      const params = urlObj.searchParams;

      const page = urlObj.href.split('?')[0].split('/').at(-1);

      let copyDivisions = window.LACROSSE_APP.constants.DIVISIONS.slice(); //copy
      let divisionsTypes = copyDivisions.reduce( (acc, item, index)=> {
        acc[item.value] = item.label_short;
        return acc;
      }, {});

      const paramsObj = Object.fromEntries(params);

      let canonicalLink = '';
      let rewrittenPath = '';
      switch (page) {
        case 'stats':
        case 'scores':
        case 'teams':
        case 'conferences':
          canonicalLink += `/${divisionsTypes[paramsObj.division]}/division/${paramsObj.division}/`
          break;
        case 'match':
          rewrittenPath = '/laxgames/index/boxscore';
          canonicalLink += `/id/${paramsObj.game_id}/year/${paramsObj.year}/`
          break;
        case 'team':
          canonicalLink += `/${paramsObj.url_name}/division/${paramsObj.division}/year/${paramsObj.year}/`
          break;
        case 'player':
          canonicalLink += `/${paramsObj.player_id}/year/${paramsObj.year}/${paramsObj.player_name}/lacrosse`
          break;
        case 'calendar':
          canonicalLink += `/${divisionsTypes[paramsObj.division]}/division/${paramsObj.division}/`
          break;
        default:
          break;
      }
      canonicalLink = canonicalLink.replace(' ', '-');
      canonicalLink = urlObj.origin + (rewrittenPath || urlObj.pathname) + canonicalLink;

      return canonicalLink;
    },
    createDateFromString: function (dateStringYmd) {
      const [y, m, d] = dateStringYmd.split('-');
      return new Date(parseInt(y), parseInt(m) - 1, parseInt(d));
    },
    setMetaTags: function({title, description, url}) {
      const head = document.head;

      setTitle(title);
      setDescription(description);
      setCanonical(this.getNewCanonical(url));

      function setTitle(title) {
        if (head.querySelector('title')) {
          document.title = title;
        } else {
          head.insertAdjacentHTML('afterbegin', `<title>${title}</title>`);
        }

        
        const metaProps = {
          'name': ['twitter:title'], 
          'property': ['og:title']
        };
        Object.keys(metaProps).forEach(key => {
          metaProps[key].forEach((propVal) => {
            if (head.querySelector(`meta[${key}="${propVal}"]`)) {
              head
                .querySelector(`meta[${key}="${propVal}"]`)
                .setAttribute('content', title);
            } else {
              head.insertAdjacentHTML(
                'afterbegin',
                `<meta ${key}="${propVal}" content="${title}">`
              );
            }
          })
        })
      }

      function setDescription(description) {
        const metaProps = {
          'name': ['description', 'twitter:description'], 
          'property': ['og:description']
        };
        Object.keys(metaProps).forEach(key => {
          metaProps[key].forEach((propVal) => {
            if (head.querySelector(`meta[${key}="${propVal}"]`)) {
              head
                .querySelector(`meta[${key}="${propVal}"]`)
                .setAttribute('content', description);
            } else {
              head.insertAdjacentHTML(
                'afterbegin',
                `<meta ${key}="${propVal}" content="${description}">`
              );
            }
          })
        })
      }

      function setCanonical(canonical) {
        if (head.querySelector(`link[rel="canonical"]`)) {
          head
            .querySelector(`link[rel="canonical"]`)
            .setAttribute('href', canonical);
        } else {
          head.insertAdjacentHTML(
            'afterbegin',
            `<link rel="canonical" href="${canonical}">`
          );
        }

        if (head.querySelector(`meta[property="og:url"]`)) {
          head
            .querySelector(`meta[property="og:url"]`)
            .setAttribute('content', canonical);
        } else {
          head.insertAdjacentHTML(
            'afterbegin',
            `<meta property="og:url" content="${canonical}">`
          );
        }
      }
    },
    getMetaTags: function(page, params) {
      const metaTags = {
        title: '',
        description: '',
        url: window.location.href,
      };
      switch (page) {
        case 'match':
        case 'team':
          metaTags.title = LACROSSE_APP.constants.PAGES_META_DATA[page].title.replace('${x}', params.title).replace('${y}', params.year);
          metaTags.description = LACROSSE_APP.constants.PAGES_META_DATA[page].description.replace('${x}', params.title).replace('${y}', params.year);
          break;
        case 'player':
          metaTags.title = LACROSSE_APP.constants.PAGES_META_DATA[page].title.replace('${x}', params.player).replace('${y}', params.year).replace('${z}', params.team);
          metaTags.description = LACROSSE_APP.constants.PAGES_META_DATA[page].description.replace('${x}', params.player).replace('${y}', params.year).replace('${z}', params.team);
          break;
        default:
          const getDivision = LACROSSE_APP.constants.DIVISIONS.find(division => division.value === Number(params.division));
          metaTags.title = LACROSSE_APP.constants.PAGES_META_DATA[page].title.replace('${x}', getDivision.label);
          metaTags.description = LACROSSE_APP.constants.PAGES_META_DATA[page].description.replace('${x}', getDivision.label);
          break;
      }
      return metaTags;
    },
    capitalizeEveryWord: function (text) {
      return text.split(' ').map(word => word[0]?.toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    },
    getPageKey: function () {
      return window.location.href;
    },
    savePageState: function ({tab = null, sorting = null}) {
      const pageKey =  window.LACROSSE_APP.utils.getPageKey();
      const pageState = {
        scrollTop: window.scrollY,
        customState: {}
      };

      if(tab) {
        pageState.customState.tab = tab;
      }
      if(sorting) {
        pageState.customState.sorting = sorting;
      }
      let stateArray = JSON.parse(sessionStorage.getItem('LACROSSE_STATS_SAVE')) || [];
      const pageIndex = stateArray.findIndex(state => state.url === pageKey);

      if (pageIndex === -1) {
        stateArray.push({ url: pageKey, stats: pageState });
      } else {
        stateArray[pageIndex].stats = pageState;
      }

      sessionStorage.setItem('LACROSSE_STATS_SAVE', JSON.stringify(stateArray));
    },
    restorePageState: function (callback) {
      const pageKey =  window.LACROSSE_APP.utils.getPageKey();
      let stateArray = JSON.parse(sessionStorage.getItem('LACROSSE_STATS_SAVE')) || [];
      const pageState = stateArray.find(state => state.url === pageKey)?.stats;

      if (pageState) {
        if (pageState.scrollTop !== null) {
          window.scrollTo(0, parseInt(pageState.scrollTop, 10));
        }
        callback(pageState.customState);
      }
    },
    handlePageBeforeUnloadState: function (params = {}) {
      window.addEventListener('beforeunload', function() {
        const saveParams = {};
        if(params.tab ){
          saveParams.tab = document.querySelector(params.tab)?.getAttribute(params.tabAttribute);
        }
        if(params.sortingBy ){
          const sortingButtons = document.querySelectorAll(params.sortingBy);
          const sortedBy = Array.from(sortingButtons).find(button => button.classList.contains('increase') || button.classList.contains('decrease'));
          if(sortedBy) {
            saveParams.sorting = {
              sortingBy: sortedBy.getAttribute(params.sortingAttribute),
              sortingByType: sortedBy.classList.contains('increase') ? 'increase' : 'decrease'
            };
          }
        }
        window.LACROSSE_APP.utils.savePageState(saveParams);
      });
    },
    handlePageBackForwardState: function (callback = () => {} ) {
      if(performance.getEntriesByType("navigation")?.[0]?.type === 'back_forward') {
        window.LACROSSE_APP.utils.restorePageState(callback);
      }
    },
    moveQuickViewBoxes: function (parentID) {
      const slider_parent = document.querySelector(parentID);
      if(slider_parent) {
        const slider_item = slider_parent.querySelectorAll('.swiper-slide');
        if(slider_item?.length) {
          slider_item.forEach(item => {
            const quickBuyPopover = item.querySelector('quick-buy-popover');
            const quickBuyDrawer = item.querySelector('quick-buy-drawer');
            if (quickBuyPopover) {
              slider_parent.append(quickBuyPopover);
            }
            if (quickBuyDrawer) {
              slider_parent.append(quickBuyDrawer);
            }
          });
        }
      }

    }
  }
};

window.addEventListener("Angle3DAddToCart", function(event) {
  const customizerId = generateUniqueEightDigitNumber();
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set('tdaId', customizerId);
  queryParams.delete('edit');
  history.replaceState(null, null, '?' + queryParams.toString());

  window.ANGLE3D_UPDATED = true;

  function generateUniqueEightDigitNumber() {
    return Math.floor(10000000 + Math.random() * 90000000);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const previewBarIframe = document.querySelector('#preview-bar-iframe');

  if (previewBarIframe) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const displayStyle = window.getComputedStyle(previewBarIframe).display;
          if (displayStyle === 'none') {
            document.documentElement.classList.add('pb-0');
          }
        }
      });
    });

    observer.observe(previewBarIframe, { attributes: true });

    const initialDisplayStyle = window.getComputedStyle(previewBarIframe).display;
    if (initialDisplayStyle === 'none') {
      document.documentElement.classList.add('pb-0');
    }
  }
});

window.clOnCartUpdate = function(){
  removeOldOptions();

  async function removeOldOptions() {
    const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
    const cartData = await cartResponse.json();
    const cartItems = cartData.items;
    if(cartItems && cartItems.length > 0) {
      const mainProducts = cartItems.filter(p => p.properties['_cl_options'] && p.properties['_preview']);
      const mainBundles = new Set(mainProducts.map(p => p.properties['_cl_options_bundle']));
      const unrelatedProducts = cartItems.filter(p =>
          p.properties['_cl_options_bundle'] &&
          !mainBundles.has(p.properties['_cl_options_bundle'])
      );

      if(unrelatedProducts && unrelatedProducts?.length > 0) {
        await removeAllItems(unrelatedProducts);
      } else {
        await updateCart();
      }
    }

    async function updateCart() {
      const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
      const cartContent = await cartResponse.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: window.themeVariables.settings.cartType === "drawer"
        }
      }));
      window.LIVE_PRODUCT_OPTION_UPDATED = true;
      if (window.themeVariables.settings.pageType === "cart") {
        window.location.reload();
      }
    }

    async function removeAllItems(unrelatedProducts) {
      const lineItemKeys = {};
      unrelatedProducts.forEach(item => {
        lineItemKeys[item.key] = 0;
      });

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({updates: lineItemKeys} )
      })
          .then(response => {
            updateCart();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  document.body.addEventListener('click', function (e) {
    const target1 = document.querySelector('.product-form .yotpo-bottom-line-scroll-panel .yotpo-sr-bottom-line-summary');
    const target2 = document.querySelector('.tda-product-details-top-container .yotpo-bottom-line-scroll-panel .yotpo-sr-bottom-line-summary');
    if ((target1 && target1.contains(e.target)) || (target2 && target2.contains(e.target))) {
      e.preventDefault();

      const reviewWidget = document.querySelector('#yotpo-reviews-main-widget');
      const header = document.querySelector('store-header');
      if (reviewWidget) {
        window.scroll({
          top: reviewWidget.getBoundingClientRect().top + window.scrollY - (header.getBoundingClientRect().height + 80),
          behavior: 'smooth',
        });
      }
    }
  });
});

window.addEventListener('DOMContentLoaded', function() {
  getLiveProductOptionEditEvent();

  function getLiveProductOptionEditEvent() {
    const headsCustomizer = document.querySelector('[data-live-options]');
    const queryParams = new URLSearchParams(window.location.search);
    if(queryParams.get('edit') && headsCustomizer) {
      setTimeout(() => {
        const btnContainer = document.querySelector('#AddToCart .loader-button__text');
        btnContainer.setAttribute('data-edit', "EDIT");
        updateButtonText("#AddToCart .loader-button__text", "#StickyAddToCart .loader-button__text", "EDIT");
        sessionStorage.setItem('LIVE_PRODUCT_OPTION_EDIT', queryParams.get('variant'));
      }, 500);
      queryParams.delete('edit');
      history.replaceState(null, null, '?' + queryParams.toString());
    }

    function updateButtonText(buttonId, spanSelector, newText) {
      const button = document.querySelector(buttonId);
      if (button && !button.disabled) {
        const textNode = Array.from(button.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim().toUpperCase() === 'ADD TO CART');
        if (textNode) {
          textNode.nodeValue = ' ' + newText;
        }
      }

      const stickyButton = document.querySelector(spanSelector);
      if (stickyButton && !stickyButton.disabled) {
        const textNode = Array.from(stickyButton.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim().toUpperCase() === 'ADD TO CART');
        if (textNode) {
          textNode.nodeValue = ' ' + newText;
        }
      }
    }
  }
});